import { Table } from '@platform/ui-library';
import { FC, useMemo } from 'react';
import { useDesign } from '../../../hooks';
import { getIntentLabels } from '../../../utilities';

export const IntentLabelTable: FC = () => {
  const serialized = useDesign();
  const {
    components: { intents },
    csvData,
    languages,
    rootSettings: { csvIntentLabelTableId }
  } = serialized;

  const intentLabels = useMemo(() => {
    // Get language-code to language label map.
    const { knowledgeBase } = window.apm;
    const languageLabels = new Map(
      knowledgeBase.getLanguages().map(({ name, value }) => {
        return [value, name];
      })
    );
    const intentLabels = getIntentLabels(serialized);

    return intents.map(({
      name
    }) => {
      return {
        Name: name,
        ...Object.fromEntries(
          languages.map(({ language }) => {
            return [
              languageLabels.get(language) ?? language,
              intentLabels.get(name)?.[language] ?? ''
            ];
          })
        )
      };
    });
  }, [csvData, intents, languages, csvIntentLabelTableId]);

  return (
    <Table
      data={intentLabels}
    />
  );
};
